const FORWARDED_PARAM_PREFIX = 'utm_';
const FORWARDED_PARAM_NAMES = new Set(['gclid', 'fbclid', 'referral']);

const isForwardedParam = (name: string): boolean => {
  const normalizedName = name.toLowerCase();
  return normalizedName.startsWith(FORWARDED_PARAM_PREFIX) || FORWARDED_PARAM_NAMES.has(normalizedName);
};

/**
 * Narrows a query string to the params worth carrying across an origin hop, so a click that
 * arrived from a campaign keeps its attribution.
 *
 * Unlisted params are dropped rather than forwarded, because the other origin is a different
 * product with its own reading of them. `as` is the one that would actively misbehave: it is the
 * dev-only host override, and forwarding it would aim the destination at the wrong storefront.
 *
 * @returns a `?`-prefixed query string, or an empty string when nothing survives.
 */
export const trackingParamsQueryString = (search: string): string => {
  const forwardedParams = new URLSearchParams();
  new URLSearchParams(search).forEach((value, name) => {
    if (isForwardedParam(name)) {
      forwardedParams.append(name, value);
    }
  });

  const query = forwardedParams.toString();
  return query.length > 0 ? `?${query}` : '';
};
